import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
export var searchBarBehavior = function searchBarBehavior() {
  Alpine.data('searchBarBehavior', function () {
    return {
      inputHasText: false,
      init: function init() {
        this.searchInput = this.$el.querySelector('.m-search-bar__input');
        this.inputHasText = !!this.searchInput.value;
      },
      bindClick: {
        '@click': function click() {
          this.searchInput.value = '';
          this.searchInput.focus();
          this.inputHasText = false;
        }
      },
      checkSearchInput: function checkSearchInput() {
        this.inputHasText = !!this.searchInput.value;
      }
    };
  });
};